import * as Api from '@ViewModels';
import { stringify as toQueryString } from 'query-string';
import { searchRequestToQueryStringParams } from '../../../../../models/UiUtils';
import { ROUTES } from '../../../../constants/routes';

export interface IPeopleSearchQueryParams {
	search?: string | string[] | null;
	sort?: string | string[] | null;
}

// searchRequestToQueryStringParams percent-encodes its output and parse() decodes one layer, so the path has to be
// built with toQueryString — interpolating raw makes the "is the URL already current?" check never match.
export const getPeopleSearchPathUpdate = (
	searchRequest: Api.IBulkContactsRequest,
	sortDescriptor: Api.ISortDescriptor | undefined,
	currentParams: IPeopleSearchQueryParams | undefined
): string | null => {
	const query = searchRequestToQueryStringParams<Api.IBulkContactsRequest>(searchRequest, sortDescriptor);
	if (!query?.search || !query?.sort) {
		return null;
	}
	if (query.search === currentParams?.search && query.sort === currentParams?.sort) {
		return null;
	}
	return `${ROUTES.contacts.people}/?${toQueryString({ search: query.search, sort: query.sort })}`;
};
